import { useCurrentStateAndParams } from "@uirouter/react";

import type { RawCompanyPageRoutingParams } from "app/pages/sales-intelligence/sub-modules/account-overview/shared/types/routing";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

function useCurrentStateAndParamsWithFixedDomain(): { state: IRouterState; params: RawCompanyPageRoutingParams } {
    const { state, params } = useCurrentStateAndParams<RawCompanyPageRoutingParams>();

    const paramsWithFixedKey: RawCompanyPageRoutingParams = {
        ...params,
        key: params.key ? params.key.split(",")[0] : "",
    };

    return {
        state,
        params: paramsWithFixedKey,
    };
}

export default useCurrentStateAndParamsWithFixedDomain;
